import "./TrustedClients.css";

import logo1 from "../../assets/logos/logo1.png";
import logo2 from "../../assets/logos/logo2.png";
import logo3 from "../../assets/logos/logo3.png";
import logo4 from "../../assets/logos/logo4.png";
import logo5 from "../../assets/logos/logo5.png";
import logo6 from "../../assets/logos/logo6.png";
import logo7 from "../../assets/logos/logo7.png";
import logo8 from "../../assets/logos/logo8.png";
import logo9 from "../../assets/logos/logo9.png";
import logo10 from "../../assets/logos/logo10.png";
import logo11 from "../../assets/logos/logo11.png";
import logo12 from "../../assets/logos/logo12.png";
import logo13 from "../../assets/logos/logo13.png";
import logo14 from "../../assets/logos/logo14.png";
import logo15 from "../../assets/logos/logo15.png";
import logo16 from "../../assets/logos/logo16.png";
import logo17 from "../../assets/logos/logo17.png";
import logo18 from "../../assets/logos/logo18.png";
import logo19 from "../../assets/logos/logo19.png";
import logo20 from "../../assets/logos/logo20.png";

const row1 = [
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
  logo10,
  logo11,
  logo12,
  logo13,
  logo14,
  logo15,
  logo16,
  logo17,
  logo18,
  logo19,
  logo20,
];

const row2 = [
  logo17,
  logo18,
  logo19,
  logo20,
  logo15,
  logo16,
  logo12,
  logo13,
  logo14,
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
  logo10,
  logo11,
];

export default function TrustedClients() {
  return (
    <section className="trusted">
      <div className="trusted-title">
        <span>TRUSTED BY</span>

        <h2>
          • Government Institutions • Schools • Universities & Colleges • Sports
          Academies •Farmhouses
        </h2>

        <p>
          India's leading organizations trust Quality Sports Surface for
          world-class sports infrastructure.
        </p>
      </div>

      <div className="logo-track">
        <div className="marquee">
          {[...row1, ...row1].map((logo, index) => (
            <div className="logo-item" key={index}>
              <img src={logo} alt="" />
            </div>
          ))}
        </div>
      </div>

      <div className="logo-track reverse">
        <div className="marquee reverseMove">
          {[...row2, ...row2].map((logo, index) => (
            <div className="logo-item" key={index}>
              <img src={logo} alt="" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
